// 数据看板-固定看板-暂无数据
<template>
  <div class="DkbGMNoData">
    <img class="icon" src="/static/images/dkb/icon_cnull.png" alt="">
    <p class="text">暂无数据</p>
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  let vm

  export default {
    name: 'DkbGMNoData',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss">
.DkbGMNoData {
  width: 100%;
  height: 1.95rem;
  border-radius: 0.1rem;
  border: 0.03rem solid #072a4b;
  box-shadow: 0 0 0.04rem rgba(0, 0, 0, 0.11) inset;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon {
    width: 1.42rem;
  }
  .text{
    margin-top: 0.1rem;
    font-size: 0.24rem;
    line-height: 0.3rem;
    // text-shadow: 0.01rem 0.01rem 0.01rem rgba(255, 255, 255, 0.18);
    background-image: -webkit-gradient(linear, left 0, right 0, from(#082844), to(#06142a));
		-webkit-background-clip: text;
	  -webkit-text-fill-color: transparent;
  }
}
div+.DkbGMNoData {
  margin-top: 0.38rem;
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/GM/NoData.vue